document.addEventListener('teeinblue-event-component-injected', function() {
	const elementToMove = document.querySelector('[id*="loox_reviews_loox_rating"]');
	const insertAfterElement = document.querySelector('.tee-product-price .tee-product-price-custom-info');
	if (elementToMove && insertAfterElement) {        
	 insertAfterElement.after(elementToMove)
	}

});

window.onload = function() {
    var checkPropertiesInterval = setInterval(function() {
        var properties = document.querySelectorAll('.upcart-item-property');
        var strongProperties = document.querySelectorAll('.upcart-item-property strong');
        
        properties.forEach(function(property) {
            if (property.textContent.includes('customization_id') || property.textContent.includes('_tib_') || property.textContent.includes('customization_image')) {
                property.style.display = 'none';
            }
        });

        strongProperties.forEach(function(strongProperty) {
            if (strongProperty.textContent.includes('customization_id') || strongProperty.textContent.includes('_tib_') || strongProperty.textContent.includes('customization_image') ) {
                strongProperty.parentElement.style.display = 'none';
            }
        });
    }, 500); 
};



